import { render, staticRenderFns } from "./UCIrvineLabReport1V2PurposeConcepts.vue?vue&type=template&id=40094bea&"
import script from "./UCIrvineLabReport1V2PurposeConcepts.vue?vue&type=script&lang=ts&"
export * from "./UCIrvineLabReport1V2PurposeConcepts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VForm,VRow})
